export default __webpack_public_path__ + "static/media/Bircher_ proportioned_170.8c40899e.jpg";